import { useRef } from 'react';
import ComicCard from '@/components/feature/ComicCard';
import { newComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (direction: 'left' | 'right') => {
    if (!scrollRef.current) return;
    const amount = 300;
    scrollRef.current.scrollBy({
      left: direction === 'left' ? -amount : amount,
      behavior: 'smooth',
    });
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full">
              最新更新
            </span>
            <h2 className="mt-3 text-2xl md:text-3xl font-heading text-foreground-950">
              本周热门 <span className="text-primary-500">新鲜出炉</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-500">精选最新更新的热门韩漫，第一时间追更不等待</p>
          </div>
          <div className="hidden md:flex items-center gap-2">
            <button
              onClick={() => scroll('left')}
              className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all duration-200 cursor-pointer"
              aria-label="向左滚动"
            >
              <i className="ri-arrow-left-s-line text-lg"></i>
            </button>
            <button
              onClick={() => scroll('right')}
              className="w-10 h-10 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-600 hover:bg-primary-500 hover:text-background-50 hover:border-primary-500 transition-all duration-200 cursor-pointer"
              aria-label="向右滚动"
            >
              <i className="ri-arrow-right-s-line text-lg"></i>
            </button>
          </div>
        </div>

        <div
          ref={scrollRef}
          className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory"
          style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
        >
          {newComics.map((comic) => (
            <div key={comic.id} className="flex-shrink-0 w-[160px] md:w-[180px] snap-start">
              <ComicCard
                id={comic.id}
                title={comic.title}
                author={comic.author}
                cover={comic.cover}
                category={comic.category}
                status={comic.status}
                rating={comic.rating}
                views={comic.views}
                isNew={comic.chapters.some((ch) => ch.isNew)}
                latestChapter={`第${comic.chapters[0].num}话`}
              />
            </div>
          ))}

          <div className="flex-shrink-0 w-[160px] md:w-[180px] snap-start flex items-center justify-center">
            <div className="text-center">
              <div className="w-full aspect-[3/4] rounded-lg bg-background-200/70 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-arrow-right-line text-3xl text-foreground-400"></i>
                  <p className="mt-2 text-xs text-foreground-500">查看更多</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}